import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=364adaba&"
import script from "./CarouselItem.vue?vue&type=script&lang=ts&"
export * from "./CarouselItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports